
import FocusConnector from '../../focus/connector';
import prevFocusable from '../../focus/get-previous-focusable';
import nextFocusable from '../../focus/get-next-focusable';
import { VISIBLE_FOCUSABLE } from '../../focus/const';

export default class SliderTabOrder {
	static SLIDER_SELECTOR				= '.et_pb_slider';
	static ARROW_PREV_SELECTOR 			= '.et-pb-arrow-prev';
	static ARROW_NEXT_SELECTOR 			= '.et-pb-arrow-next';
	static SLIDES_SELECTOR 				= '.et_pb_slides';
	static SLIDE_ACTIVE_SELECTOR		= '.et-pb-active-slide';
	static CONTROLLERS_BUTTON_SELECTOR	= '.et-pb-controllers button';
	static FIRST_FOCUS_ELEMENT_SELECTOR	= 'first-focus-element-';
	static LAST_FOCUS_ELEMENT_SELECTOR	= 'last-focus-element-';

	start() {
		if ($('.ENABLE_SLIDER_TAB_ORDER').length === 0) {
			return;
		}
		this.sliderTabOrder();
	}

	sliderTabOrder() {
		$(window).on('load', () => {
			$(SliderTabOrder.SLIDER_SELECTOR).each((sliderIndex, slider) => {
				const sliderObj = $(slider);
				let existingItems = [];
				let connectorElements = [];
				const linkFocusConnectors = () => {
					const getAllFocusableFromActiveSlide = () => sliderObj.find(SliderTabOrder.SLIDE_ACTIVE_SELECTOR)
						.find(VISIBLE_FOCUSABLE);
					const selectors = [
						`#${SliderTabOrder.FIRST_FOCUS_ELEMENT_SELECTOR}${sliderIndex}`,
						SliderTabOrder.ARROW_PREV_SELECTOR,
						SliderTabOrder.ARROW_NEXT_SELECTOR,
						SliderTabOrder.SLIDE_ACTIVE_SELECTOR,
						getAllFocusableFromActiveSlide(),
						SliderTabOrder.CONTROLLERS_BUTTON_SELECTOR,
						`#${SliderTabOrder.LAST_FOCUS_ELEMENT_SELECTOR}${sliderIndex}`,
					];

					existingItems = [];
					selectors.forEach((item) => {
						let items;
						if (typeof item === 'string') {
							items = sliderObj.find(item);
						} else {
							items = item;
						}
						for (let i = 0; i < items.length; i++) {
							existingItems.push(items.get(i));
						}
						//make all existing elements focusable programmatically
						sliderObj.find(SliderTabOrder.SLIDE_ACTIVE_SELECTOR).attr('tabindex', -1);
					});

					for (let i = 1; i < existingItems.length; i++) {
						connectorElements[i - 1] = new FocusConnector(existingItems[i - 1], existingItems[i]);
						connectorElements[i - 1].link();
					}
				};
				const treatFocusInsideSlide = () => {
					if ($(':focus').parents().is(sliderObj.find(SliderTabOrder.SLIDES_SELECTOR))) {
						sliderObj.find(SliderTabOrder.SLIDE_ACTIVE_SELECTOR).get(0).focus();
					}
				};
				//add first and list additional elements to be able to manipulate the slide order
				sliderObj.prepend(`<div id="${SliderTabOrder.FIRST_FOCUS_ELEMENT_SELECTOR}${sliderIndex}" tabindex="0"></div>`);
				sliderObj.append(`<div id="${SliderTabOrder.LAST_FOCUS_ELEMENT_SELECTOR}${sliderIndex}" tabindex="0"></div>`);
				linkFocusConnectors();
				if (existingItems.length > 1) {
					//redirect focus to the first element from slider
					$(`#${SliderTabOrder.FIRST_FOCUS_ELEMENT_SELECTOR}${sliderIndex}`).on('focus', function(e) {
						if ($(e.relatedTarget).parents().is(sliderObj)) {
							prevFocusable(this).focus();
						} else {
							$(existingItems[1]).get(0).focus();
						}
					});
					//redirect focus to the last element from slider
					$(`#${SliderTabOrder.LAST_FOCUS_ELEMENT_SELECTOR}${sliderIndex}`).on('focus', function(e) {
						if ($(e.relatedTarget).parents().is(sliderObj)) {
							nextFocusable(this).focus();
						} else {
							$(existingItems[existingItems.length - 2]).get(0).focus();
						}
					});
					//refresh the tab order after each change of the slider
					const observer = new MutationObserver(() => {
						for (let i = 0; i < connectorElements.length; i++) {
							connectorElements[i].unlink();
						}
						connectorElements = [];
						linkFocusConnectors();
						treatFocusInsideSlide();
					});
					observer.observe(sliderObj[0], {
						attributes: 'true',
						attributeFilter: ['class'],
					});
				}
			});
		});
	}
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/slider/controllers/slider-tab-order.js